module.exports = __webpack_public_path__ + "static/avatar-fdcdb68f654b6d30c26a3d0d667b1450.jpg";